export const CASH_LOCATION_NOT_FOUND = 'CASH_LOCATION_NOT_FOUND';
export const CASH_LOCATION_INACTIVE = 'CASH_LOCATION_INACTIVE';
export const CASH_LOCATION_INVALID_TYPE = 'CASH_LOCATION_INVALID_TYPE';
export const CASH_LOCATION_ALREADY_DISABLED = 'CASH_LOCATION_ALREADY_DISABLED';
export const CASH_STATION_CONTEXT_REQUIRED = 'CASH_STATION_CONTEXT_REQUIRED';
export const CASH_REPORT_ACTOR_EVIDENCE_INVALID = 'CASH_REPORT_ACTOR_EVIDENCE_INVALID';

export const CASH_SESSION_NOT_FOUND = 'CASH_SESSION_NOT_FOUND';
export const CASH_SESSION_ALREADY_OPEN = 'CASH_SESSION_ALREADY_OPEN';
export const CASH_SESSION_NOT_OPEN = 'CASH_SESSION_NOT_OPEN';
export const CASH_SESSION_CLOSED = 'CASH_SESSION_CLOSED';
export const CASH_SESSION_DENOMINATIONS_REQUIRED = 'CASH_SESSION_DENOMINATIONS_REQUIRED';
export const CASH_SESSION_DENOMINATION_MISMATCH = 'CASH_SESSION_DENOMINATION_MISMATCH';
export const CASH_SESSION_OPENING_COUNT_REQUIRED = 'CASH_SESSION_OPENING_COUNT_REQUIRED';
export const CASH_SESSION_FORCE_CLOSE_REASON_REQUIRED = 'CASH_SESSION_FORCE_CLOSE_REASON_REQUIRED';
export const CASH_SESSION_FORCE_CLOSE_COUNT_REQUIRED = 'CASH_SESSION_FORCE_CLOSE_COUNT_REQUIRED';
export const CASH_SESSION_FORCE_CLOSE_UNVERIFIED_COUNT_FORBIDDEN =
  'CASH_SESSION_FORCE_CLOSE_UNVERIFIED_COUNT_FORBIDDEN';

export const CASH_DENOMINATION_SNAPSHOT_NOT_FOUND = 'CASH_DENOMINATION_SNAPSHOT_NOT_FOUND';
export const CASH_DENOMINATION_SNAPSHOT_UNSUPPORTED_KIND =
  'CASH_DENOMINATION_SNAPSHOT_UNSUPPORTED_KIND';
export const CASH_DENOMINATION_SNAPSHOT_UNSUPPORTED_CONFIDENCE =
  'CASH_DENOMINATION_SNAPSHOT_UNSUPPORTED_CONFIDENCE';
export const CASH_DENOMINATION_SNAPSHOT_INVALID_DENOMINATION =
  'CASH_DENOMINATION_SNAPSHOT_INVALID_DENOMINATION';
export const CASH_DENOMINATION_SNAPSHOT_TOTAL_MISMATCH =
  'CASH_DENOMINATION_SNAPSHOT_TOTAL_MISMATCH';
export const CASH_DENOMINATION_ALLOCATION_NOT_FOUND = 'CASH_DENOMINATION_ALLOCATION_NOT_FOUND';
export const CASH_DENOMINATION_ALLOCATION_INVALID = 'CASH_DENOMINATION_ALLOCATION_INVALID';
export const CASH_DENOMINATION_ALLOCATION_TOTAL_MISMATCH =
  'CASH_DENOMINATION_ALLOCATION_TOTAL_MISMATCH';
export const CASH_DENOMINATION_ALLOCATION_UNSUPPORTED_MOVEMENT =
  'CASH_DENOMINATION_ALLOCATION_UNSUPPORTED_MOVEMENT';
export const CASH_DENOMINATION_BASELINE_INVALID = 'CASH_DENOMINATION_BASELINE_INVALID';
export const CASH_DENOMINATION_BASELINE_SOURCE_REQUIRED =
  'CASH_DENOMINATION_BASELINE_SOURCE_REQUIRED';
export const CASH_DENOMINATION_BASELINE_PROMOTION_REQUIRES_VARIANCE_LINK =
  'CASH_DENOMINATION_BASELINE_PROMOTION_REQUIRES_VARIANCE_LINK';
export const CASH_DENOMINATION_INVENTORY_CHECKPOINT_INVALID =
  'CASH_DENOMINATION_INVENTORY_CHECKPOINT_INVALID';
export const CASH_DENOMINATION_INVENTORY_CHECKPOINT_IDEMPOTENCY_CONFLICT =
  'CASH_DENOMINATION_INVENTORY_CHECKPOINT_IDEMPOTENCY_CONFLICT';

export const CASH_EXPENSE_NOT_FOUND = 'CASH_EXPENSE_NOT_FOUND';
export const CASH_EXPENSE_ALREADY_VOIDED = 'CASH_EXPENSE_ALREADY_VOIDED';
export const CASH_EXPENSE_INVALID_SOURCE = 'CASH_EXPENSE_INVALID_SOURCE';
export const CASH_EXPENSE_SOURCE_SCOPE_MISMATCH = 'CASH_EXPENSE_SOURCE_SCOPE_MISMATCH';
export const CASH_EXPENSE_SOURCE_INSUFFICIENT_FUNDS = 'CASH_EXPENSE_SOURCE_INSUFFICIENT_FUNDS';
export const CASH_EXPENSE_SOURCE_AUTHORITATIVE_SURFACE_REQUIRED =
  'CASH_EXPENSE_SOURCE_AUTHORITATIVE_SURFACE_REQUIRED';
export const CASH_EXPENSE_CATEGORY_NOT_FOUND = 'CASH_EXPENSE_CATEGORY_NOT_FOUND';
export const CASH_EXPENSE_CATEGORY_INACTIVE = 'CASH_EXPENSE_CATEGORY_INACTIVE';
export const CASH_EXPENSE_CATEGORY_ALREADY_DISABLED = 'CASH_EXPENSE_CATEGORY_ALREADY_DISABLED';
export const CASH_FUNDING_SOURCE_CATEGORY_NOT_FOUND = 'CASH_FUNDING_SOURCE_CATEGORY_NOT_FOUND';
export const CASH_FUNDING_SOURCE_CATEGORY_REQUIRED = 'CASH_FUNDING_SOURCE_CATEGORY_REQUIRED';
export const CASH_FUNDING_SOURCE_CATEGORY_INACTIVE = 'CASH_FUNDING_SOURCE_CATEGORY_INACTIVE';
export const CASH_FUNDING_SOURCE_CATEGORY_LOCAL_ONLY_NOT_ALLOWED =
  'CASH_FUNDING_SOURCE_CATEGORY_LOCAL_ONLY_NOT_ALLOWED';
export const CASH_FUNDING_SOURCE_CATEGORY_OTHER_NOTE_REQUIRED =
  'CASH_FUNDING_SOURCE_CATEGORY_OTHER_NOTE_REQUIRED';
export const CASH_FUNDING_SOURCE_CATEGORY_CODE_CONFLICT =
  'CASH_FUNDING_SOURCE_CATEGORY_CODE_CONFLICT';
export const CASH_FUNDING_SOURCE_CATEGORY_ALREADY_DISABLED =
  'CASH_FUNDING_SOURCE_CATEGORY_ALREADY_DISABLED';
export const CASH_PREREQUISITE_MISSING = 'CASH_PREREQUISITE_MISSING';
export const CASH_PREREQUISITE_INACTIVE = 'CASH_PREREQUISITE_INACTIVE';
export const CASH_PREREQUISITE_NOT_AUTHORITATIVE = 'CASH_PREREQUISITE_NOT_AUTHORITATIVE';

export const CASH_TRANSFER_NOT_FOUND = 'CASH_TRANSFER_NOT_FOUND';
export const CASH_TRANSFER_INVALID = 'CASH_TRANSFER_INVALID';
export const CASH_DRAWER_INSUFFICIENT_FUNDS = 'CASH_DRAWER_INSUFFICIENT_FUNDS';
export const CASH_TRANSFER_DRAWER_TO_DRAWER_FORBIDDEN = 'CASH_TRANSFER_DRAWER_TO_DRAWER_FORBIDDEN';
export const CASH_TRANSFER_CROSS_STORE_FORBIDDEN = 'CASH_TRANSFER_CROSS_STORE_FORBIDDEN';
export const CASH_TRANSFER_NOTE_REQUIRED = 'CASH_TRANSFER_NOTE_REQUIRED';
export const CASH_DRAWER_REFILL_SELF_LIMIT_EXCEEDED = 'CASH_DRAWER_REFILL_SELF_LIMIT_EXCEEDED';

export const CASH_TREASURY_DISTRIBUTION_REQUEST_NOT_FOUND =
  'CASH_TREASURY_DISTRIBUTION_REQUEST_NOT_FOUND';
export const CASH_TREASURY_DISTRIBUTION_REQUEST_INVALID_STATE =
  'CASH_TREASURY_DISTRIBUTION_REQUEST_INVALID_STATE';
export const CASH_TREASURY_DISTRIBUTION_INSUFFICIENT_AVAILABLE_BALANCE =
  'CASH_TREASURY_DISTRIBUTION_INSUFFICIENT_AVAILABLE_BALANCE';
export const CASH_TREASURY_DISTRIBUTION_TARGET_INVALID =
  'CASH_TREASURY_DISTRIBUTION_TARGET_INVALID';
export const CASH_TREASURY_DISTRIBUTION_MIRROR_NOT_READY =
  'CASH_TREASURY_DISTRIBUTION_MIRROR_NOT_READY';

export const CASH_ACCEPTED_OPENING_FORBIDDEN = 'CASH_ACCEPTED_OPENING_FORBIDDEN';
export const CASH_CONFIGURATION_MANAGED_BY_CLOUD = 'CASH_CONFIGURATION_MANAGED_BY_CLOUD';

export const CASH_TREASURY_ACTION_FORBIDDEN = 'CASH_TREASURY_ACTION_FORBIDDEN';
export const CASH_TREASURY_ACTION_BLOCKED_OFFLINE_ONLY =
  'CASH_TREASURY_ACTION_BLOCKED_OFFLINE_ONLY';
export const CASH_TREASURY_DISABLED = 'CASH_TREASURY_DISABLED';
export const CASH_DIRECT_VAULT_INTAKE_DISABLED = 'CASH_DIRECT_VAULT_INTAKE_DISABLED';
export const CASH_OPERATIONAL_FUNDING_DESKTOP_AUTHORITATIVE =
  'CASH_OPERATIONAL_FUNDING_DESKTOP_AUTHORITATIVE';
export const CASH_TREASURY_FUNDING_TARGET_INVALID = 'CASH_TREASURY_FUNDING_TARGET_INVALID';
export const CASH_TREASURY_FUNDING_SOURCE_TYPE_INVALID =
  'CASH_TREASURY_FUNDING_SOURCE_TYPE_INVALID';
export const CASH_TREASURY_FUNDING_NOT_FOUND = 'CASH_TREASURY_FUNDING_NOT_FOUND';
export const CASH_TREASURY_FUNDING_INVALID_STATE = 'CASH_TREASURY_FUNDING_INVALID_STATE';
export const CASH_TREASURY_COUNT_IN_PROGRESS = 'CASH_TREASURY_COUNT_IN_PROGRESS';
export const CASH_TREASURY_COUNT_LOCK_NOT_FOUND = 'CASH_TREASURY_COUNT_LOCK_NOT_FOUND';
export const CASH_TREASURY_COUNT_LOCK_STALE = 'CASH_TREASURY_COUNT_LOCK_STALE';
export const CASH_TREASURY_COUNT_LOCK_VERSION_MISMATCH =
  'CASH_TREASURY_COUNT_LOCK_VERSION_MISMATCH';
export const CASH_TREASURY_COUNT_STALE_EXPECTED_BALANCE =
  'CASH_TREASURY_COUNT_STALE_EXPECTED_BALANCE';
export const CASH_TREASURY_COUNT_DENOMINATION_REQUIRED =
  'CASH_TREASURY_COUNT_DENOMINATION_REQUIRED';
export const CASH_TREASURY_COUNT_DENOMINATION_TOTAL_MISMATCH =
  'CASH_TREASURY_COUNT_DENOMINATION_TOTAL_MISMATCH';
export const CASH_TREASURY_COUNT_IDEMPOTENCY_CONFLICT = 'CASH_TREASURY_COUNT_IDEMPOTENCY_CONFLICT';
export const CASH_TREASURY_STARTING_COUNT_ALREADY_EXISTS =
  'CASH_TREASURY_STARTING_COUNT_ALREADY_EXISTS';
export const CASH_VAULT_INTAKE_TARGET_INVALID = 'CASH_VAULT_INTAKE_TARGET_INVALID';
export const CASH_VAULT_INTAKE_SOURCE_TYPE_INVALID = 'CASH_VAULT_INTAKE_SOURCE_TYPE_INVALID';
export const CASH_VAULT_INTAKE_REFERENCE_REQUIRED = 'CASH_VAULT_INTAKE_REFERENCE_REQUIRED';
export const CASH_VAULT_INTAKE_NOTE_REQUIRED = 'CASH_VAULT_INTAKE_NOTE_REQUIRED';

export const CASH_VARIANCE_CASE_NOT_FOUND = 'CASH_VARIANCE_CASE_NOT_FOUND';
export const CASH_VARIANCE_CASE_RESOLVED = 'CASH_VARIANCE_CASE_RESOLVED';
export const CASH_VARIANCE_ACTION_NOT_FOUND = 'CASH_VARIANCE_ACTION_NOT_FOUND';
export const CASH_VARIANCE_ACTION_NOT_PENDING = 'CASH_VARIANCE_ACTION_NOT_PENDING';
export const CASH_VARIANCE_RECOVERY_DIRECTION_INVALID = 'CASH_VARIANCE_RECOVERY_DIRECTION_INVALID';
export const CASH_VARIANCE_AMOUNT_EXCEEDS_OUTSTANDING = 'CASH_VARIANCE_AMOUNT_EXCEEDS_OUTSTANDING';
export const CASH_VARIANCE_CASE_PAIR_INVALID = 'CASH_VARIANCE_CASE_PAIR_INVALID';
export const CASH_VARIANCE_CLASSIFICATION_INVALID = 'CASH_VARIANCE_CLASSIFICATION_INVALID';
export const CASH_SYNC_REQUEUE_NOT_ALLOWED = 'CASH_SYNC_REQUEUE_NOT_ALLOWED';
export const CASH_SYNC_REQUEUE_NOT_READY = 'CASH_SYNC_REQUEUE_NOT_READY';

export const CASH_OPERATION_IDEMPOTENCY_CONFLICT = 'CASH_OPERATION_IDEMPOTENCY_CONFLICT';
export const CASH_OPERATING_MODE_CONTROL_REQUIRED = 'CASH_OPERATING_MODE_CONTROL_REQUIRED';
export const CASH_OPERATING_MODE_TRANSITION_BLOCKED = 'CASH_OPERATING_MODE_TRANSITION_BLOCKED';
export const CASH_OPERATING_CONFIGURATION_REVISION_CONFLICT =
  'CASH_OPERATING_CONFIGURATION_REVISION_CONFLICT';
export const CASH_OPERATING_CONFIGURATION_INVALID = 'CASH_OPERATING_CONFIGURATION_INVALID';
export const CASH_MODE_ACTIVATION_NOT_FOUND = 'CASH_MODE_ACTIVATION_NOT_FOUND';
export const CASH_MODE_ACTIVATION_INVALID_STATE = 'CASH_MODE_ACTIVATION_INVALID_STATE';
export const CASH_MODE_ACTIVATION_COUNTS_INCOMPLETE = 'CASH_MODE_ACTIVATION_COUNTS_INCOMPLETE';
export const CASH_MODE_ACTIVATION_NOT_READY = 'CASH_MODE_ACTIVATION_NOT_READY';
export const CASH_NEEDED_REQUEST_NOT_FOUND = 'CASH_NEEDED_REQUEST_NOT_FOUND';
export const CASH_NEEDED_REQUEST_ACTIVE_EXISTS = 'CASH_NEEDED_REQUEST_ACTIVE_EXISTS';
export const CASH_NEEDED_REQUEST_INVALID_STATE = 'CASH_NEEDED_REQUEST_INVALID_STATE';
export const CASH_NEEDED_REQUEST_REFILL_MISMATCH = 'CASH_NEEDED_REQUEST_REFILL_MISMATCH';
export const CASH_LOCAL_TRANSFER_REVERSAL_INVALID = 'CASH_LOCAL_TRANSFER_REVERSAL_INVALID';
export const CASH_LOCAL_TRANSFER_REPLACEMENT_INVALID = 'CASH_LOCAL_TRANSFER_REPLACEMENT_INVALID';
export const CASH_LOCAL_TRANSFER_CORRECTION_INVALID = 'CASH_LOCAL_TRANSFER_CORRECTION_INVALID';
export const CASH_EXPENSE_METADATA_CORRECTION_INVALID = 'CASH_EXPENSE_METADATA_CORRECTION_INVALID';
export const CASH_EXPENSE_REPLACEMENT_INVALID = 'CASH_EXPENSE_REPLACEMENT_INVALID';
export const CASH_DENOMINATION_CORRECTION_FORBIDDEN = 'CASH_DENOMINATION_CORRECTION_FORBIDDEN';
export const CASH_DENOMINATION_CORRECTION_AMOUNT_MISMATCH =
  'CASH_DENOMINATION_CORRECTION_AMOUNT_MISMATCH';
export const CASH_CUSTODY_RECEIPT_NOT_FOUND = 'CASH_CUSTODY_RECEIPT_NOT_FOUND';
export const CASH_CUSTODY_RECEIPT_INVALID_STATE = 'CASH_CUSTODY_RECEIPT_INVALID_STATE';
export const CASH_CUSTODY_RECEIPT_INSTRUCTION_MISMATCH =
  'CASH_CUSTODY_RECEIPT_INSTRUCTION_MISMATCH';
export const CASH_CUSTODY_RECEIPT_INSTRUCTION_ALREADY_USED =
  'CASH_CUSTODY_RECEIPT_INSTRUCTION_ALREADY_USED';
export const CASH_CUSTODY_RECEIPT_INSUFFICIENT_AVAILABLE_BALANCE =
  'CASH_CUSTODY_RECEIPT_INSUFFICIENT_AVAILABLE_BALANCE';
export const CASH_VAULT_REMITTANCE_NOT_FOUND = 'CASH_VAULT_REMITTANCE_NOT_FOUND';
export const CASH_VAULT_REMITTANCE_INVALID_STATE = 'CASH_VAULT_REMITTANCE_INVALID_STATE';
export const CASH_VAULT_REMITTANCE_INSUFFICIENT_AVAILABLE_BALANCE =
  'CASH_VAULT_REMITTANCE_INSUFFICIENT_AVAILABLE_BALANCE';
export const CASH_VAULT_REMITTANCE_DESTINATION_INVALID =
  'CASH_VAULT_REMITTANCE_DESTINATION_INVALID';
